export default __webpack_public_path__ + "static/media/home_product_img5_Hk.e405bf62.webp";